<script setup lang="ts">
import CiSkeletonItem from '@/components/skeleton/CiSkeletonItem.vue';
</script>

<template>
  <div class="skeleton__wrapper">
    <div class="container">
      <div class="lg:mb-6 lg:mt-4">
        <CiSkeletonItem class="mx-auto mb-4 block h-[130px] py-12 lg:mx-0 lg:mt-2 lg:h-5 lg:w-[70%] lg:py-0" />
      </div>

      <div class="mt-[-45px] grid grid-cols-12 lg:mt-0 lg:pt-12">
        <div class="col-span-12 lg:col-span-2">
          <div class="mx-auto w-4/12 md:w-3/12 lg:w-10/12">
            <CiSkeletonItem
              class="m-0 h-auto w-full rounded-full pt-[100%] md:ml-[10%] md:w-4/5 md:pt-[80%] lg:m-0 lg:size-[95px] lg:pt-0 xl:size-[120px]"
            />
          </div>
          <div class="mt-6 w-full lg:mt-0">
            <CiSkeletonItem class="mx-auto my-0 h-5 w-1/2 lg:my-[2px] lg:w-4/5" />
            <CiSkeletonItem class="mx-auto h-5 w-1/2 lg:my-[2px] lg:w-4/5" />
          </div>
        </div>
        <div class="order-1 col-span-12 hidden items-end lg:order-2 lg:col-span-10 lg:mt-6 lg:flex">
          <div class="w-full">
            <CiSkeletonItem class="h-10 w-[70%]" />
          </div>
        </div>
      </div>

      <div class="my-12">
        <CiSkeletonItem class="h-[400px] w-full" />
        <CiSkeletonItem class="h-[400px] w-full lg:mt-6" />
        <CiSkeletonItem class="h-[400px] w-full lg:mt-6" />
      </div>
    </div>
  </div>
</template>
